<template>
  <v-dialog
    v-model="DIALOG_ATIVO"
    max-width="700"
    content-class="bra-15"
    persistent
  >
    <v-card>
      <v-card-title class="pt-5 pb-3">
        <div>
          <slot name="titulo-lado-esquerdo">
            <p class="ma-0 font-21">Mix de Produtos das Filiais</p>
            <p class="ma-0 font-12 mt-n3 font-weight-regular text-gray-800">
              Selecione os filtros abaixo para acessar os produtos na tela de configuração
            </p>
          </slot>
        </div>

        <v-spacer />

        <v-btn class="ml-n2" color="#000" icon @click="DIALOG_ATIVO = false">
          <v-icon size="25">$X</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <div class="pb-3 pl-1">
          <div class="position-absolute ml-2 mt-n10px h-15px font-12 bg-white z-999 px-1">Selecione uma ou mais filiais</div>

          <FiltroFilialAutocomplete
            v-model="filtros.filiais"
            outlined
            multiple
            :qtde-visivel-selecionados="5"
            clearable
            hide-details
            append-icon="$CaretDown"
            :dense="autocomplete_dense"
            @focus="focus_inputs.filial = true"
            @blur="focus_inputs.filial = false"
          >
            <template #prepend-inner v-if="filtros.filiais.length === 0 && !focus_inputs.filial">
              <div class="position-absolute mt-1">Geral</div>
            </template>
          </FiltroFilialAutocomplete>
        </div>

        <DivisorComLegenda
          legenda="Filtros gerais (lista de produtos do mix)"
          class="mt-3 mb-7"
        />

        <FiltrosPrincipais :filtros="filtros" />

        <div class="d-flex">
          <div class="pl-1 pb-3 w-50-porcento">
            <div class="position-absolute ml-2 mt-n10px font-12 bg-white z-999 px-1">Curva Popularidade</div>

            <FiltrosAutocomplete
              v-model="filtros.curva_popularidade"
              :items="selects.curva_popularidade"
              outlined
              multiple
              :qtde-visivel-selecionados="1"
              clearable
              hide-details
              append-icon="mdi-filter"
              :dense="autocomplete_dense"
              @focus="focus_inputs.curva_popularidade = true"
              @blur="focus_inputs.curva_popularidade = false"
            >
              <template #prepend-inner
                        v-if="filtros.curva_popularidade.length === 0 && !focus_inputs.curva_popularidade">
                <div class="position-absolute mt-1">Geral</div>
              </template>
            </FiltrosAutocomplete>
          </div>

          <div class="pl-2 pb-3 w-50-porcento">
            <div class="position-absolute ml-2 mt-n10px font-12 bg-white z-999 px-1">Curva Faturamento</div>

            <FiltrosAutocomplete
              v-model="filtros.curva_financeira"
              :items="selects.curva_financeira"
              outlined
              multiple
              :qtde-visivel-selecionados="1"
              clearable
              hide-details
              append-icon="mdi-filter"
              :dense="autocomplete_dense"
              @focus="focus_inputs.curva_financeira = true"
              @blur="focus_inputs.curva_financeira = false"
            >
              <template #prepend-inner v-if="filtros.curva_financeira.length === 0 && !focus_inputs.curva_financeira">
                <div class="position-absolute mt-1">Geral</div>
              </template>
            </FiltrosAutocomplete>
          </div>
        </div>

        <div class="d-flex">
          <div class="pl-1 pb-3 w-50-porcento">
            <div class="position-absolute ml-2 mt-n10px font-12 bg-white z-999 px-1">Movimentação</div>

            <FiltrosAutocomplete
              v-model="filtros.movimentacao"
              :items="selects.movimentacao"
              outlined
              multiple
              :qtde-visivel-selecionados="1"
              clearable
              hide-details
              append-icon="mdi-filter"
              :dense="autocomplete_dense"
              @focus="focus_inputs.movimentacao = true"
              @blur="focus_inputs.movimentacao = false"
            >
              <template #prepend-inner v-if="filtros.movimentacao.length === 0 && !focus_inputs.movimentacao">
                <div class="position-absolute mt-1">Geral</div>
              </template>
            </FiltrosAutocomplete>
          </div>

          <div class="pb-3 pl-2 w-50-porcento">
            <div class="position-absolute ml-2 mt-n10px font-12 bg-white z-999 px-1">Pertence ao Mix (Sim ou Não)</div>

            <FiltrosAutocomplete
              v-model="filtros.pertence_ao_mix"
              :items="selects.pertence_ao_mix"
              outlined
              multiple
              :qtde-visivel-selecionados="1"
              clearable
              hide-details
              append-icon="mdi-filter"
              :dense="autocomplete_dense"
              @focus="focus_inputs.pertence_ao_mix = true"
              @blur="focus_inputs.pertence_ao_mix = false"
            >
              <template #prepend-inner v-if="filtros.pertence_ao_mix.length === 0 && !focus_inputs.pertence_ao_mix">
                <div class="position-absolute mt-1">Geral</div>
              </template>
            </FiltrosAutocomplete>
          </div>
        </div>

        <div class="d-flex">
          <div class="pb-3 pl-1 w-50-porcento">
            <div class="position-absolute ml-2 mt-n10px font-12 bg-white z-999 px-1">
              Possui Venda nos Últimos X Dias
            </div>

            <v-text-field
              v-model.number="filtros.possui_venda_ultimos_dias"
              placeholder="0"
              type="number"
              outlined
              clearable
              hide-details
              :dense="autocomplete_dense"
              min="0"
              step="1"
              suffix="dias"
              @focus="focus_inputs.possui_venda_ultimos_dias = true"
              @blur="focus_inputs.possui_venda_ultimos_dias = false"
              @wheel.native="$event.target.blur()"
              @keypress.native="($event.key < '0' || $event.key > '9') && $event.preventDefault()"
            />
          </div>
        </div>

        <div class="d-flex">
          <div class="pr-2 w-50-porcento">
            <DivisorComLegenda
              legenda="Flags de compra dos produtos combinados"
              class="mb-4 mt-4"
            />

            <div>
              <v-checkbox
                v-model="filtros.produtos_combinados"
                color="#4075FF"
                label="Produtos Combinados"
              />

              <v-checkbox
                v-model="filtros.produtos_nao_combinados"
                class="mt-n4"
                color="#4075FF"
                label="Produtos Não Combinados"
              />
            </div>
          </div>

          <div class="pl-1 w-50-porcento">
            <DivisorComLegenda
              legenda="Status"
              class="mb-4 mt-4"
            />

            <div>
              <v-checkbox
                v-model="filtros.produtos_ativos"
                color="#4075FF"
                label="Ativo"
              />

              <v-checkbox
                v-model="filtros.produtos_inativos"
                class="mt-n4"
                color="#4075FF"
                label="Inativo"
              />
            </div>
          </div>
        </div>

        <v-divider class="mb-3" />

        <div class="d-flex align-center">
          <v-switch
            v-model="filtros.produtos_estoque_zero"
            hide-details
            color="#4075FF"
          >
            <template #label>
              <div class="d-flex flex-column">
                <span style="color: #19191C; font-weight: 400" class="pl-2">Filtrar Estoque Zerado</span>
                <span style="color: #68686E" class="font-14 pl-2">Apenas os itens com estoque = 0 serão exibidos</span>
              </div>
            </template>
          </v-switch>
        </div>

        <v-divider class="mt-3 mb-3" />

        <div class="d-flex justify-end pt-1">
          <v-btn
            color="#013254"
            v-text="'Cancelar'"
            width="170"
            class="ml-3 text-none border-gray-400"
            outlined
            @click="DIALOG_ATIVO = false"
          />

          <v-btn
            color="#013254"
            v-text="'Aplicar'"
            width="170"
            style="color: #ffffff;"
            class="ml-3 text-none"
            @click="aplicarFiltros"
          />
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import FiltroExibirProdutosInativos from "@/components/compra/ProdutosGerais/Filtros/FiltroExibirProdutosInativos.vue";
import FiltrosAutocomplete from "@/components/compra/ProdutosGerais/Filtros/FiltrosAutocomplete.vue";
import DivisorComLegenda from "@/components/utils/DivisorComLegenda.vue";

import FiltrosPrincipais
  from "@/components/MixProdutosFilial/componentes/FiltrosMixProdutosFilial/FiltrosPrincipais.vue";
import BlocoFiltrosPrincipais from "@/components/compra/ProdutosGerais/Filtros/BlocoFiltrosPrincipais.vue";
import FiltroFilialAutocomplete
  from "@/components/MixProdutosFilial/componentes/FiltrosMixProdutosFilial/FiltroFilialAutocomplete.vue";

export default {
  name: "FiltrosMixProdutosFilial",
  components: {
    FiltroFilialAutocomplete,
    BlocoFiltrosPrincipais,
    FiltrosPrincipais,
    FiltroExibirProdutosInativos,
    DivisorComLegenda,
    FiltrosAutocomplete,
  },
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    modelValue: Boolean,
    autocomplete_dense: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    filtros: {
      filiais: [],
      fornecedores: [],
      segmentos: [],
      secoes: [],
      categorias: [],
      curva_popularidade: [],
      curva_financeira: [],
      possui_venda_ultimos_dias: [],
      movimentacao: [],
      pertence_ao_mix: [],
      produtos_combinados: false,
      produtos_nao_combinados: true,
      produtos_ativos: true,
      produtos_inativos: false,
      produtos_estoque_zero: false
    },
    focus_inputs: {
      filial: false,
      fornecedor: false,
      segmento: false,
      secao: false,
      categoria: false,
      curva_popularidade: false,
      curva_financeira: false,
      possui_venda_ultimos_dias: false,
      movimentacao: false,
      pertence_ao_mix: false
    },
    selects: {
      status_compra: [
        { valor: 1, descricao: 'Itens a comprar' },
        { valor: 2, descricao: 'Itens em completar compra' },
        { valor: 3, descricao: 'Itens em trânsito' },
      ],
      pertence_ao_mix: [
        { valor: 'S', descricao: '1. Sim' },
        { valor: 'N', descricao: '2. Não' }
      ],
      movimentacao: [
        { valor: 'PROPRIA', descricao: '1. Própria' },
        { valor: 'MISTA', descricao: '2. Mista' },
        { valor: 'RETIRA', descricao: '3. Retira' }
      ],
      curva_popularidade: [
        { valor: 'P', descricao: '1. Frequência Alta de Saída' },
        { valor: 'Q', descricao: '2. Frequência Média de Saída' },
        { valor: 'R', descricao: '3. Frequência Baixa de Saída' }
      ],
      curva_financeira: [
        { valor: 'Z', descricao: '1. Faturamento Elevado' },
        { valor: 'Y', descricao: '2. Faturamento Médio' },
        { valor: 'X', descricao: '3. Faturamento Baixo' }
      ],
      default: [
        { valor: 'A', descricao: 'A' },
        { valor: 'B', descricao: 'B' },
        { valor: 'C', descricao: 'C' }
      ]
    },
  }),
  computed: {
    DIALOG_ATIVO: {
      get: function () {
        return this.modelValue;
      },
      set: function (valor) {
        this.$emit('update:modelValue', valor);
      }
    }
  },
  methods: {
    aplicarFiltros() {
      this.$emit('update:filtros', this.filtros);
      this.DIALOG_ATIVO = false;
    }
  }
}
</script>

<style scoped>

</style>
